import { BaseModel, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import EmployerFilterGroup from './EmployerFilterGroup'
import EmployerSortField from './EmployerSortField'

const DEFAULT_SORT_KEY = '-vacancies_count_new'

export default class EmployerFilters extends BaseModel {
  static override constructorName = 'EmployerFilters'

  groups: EmployerFilterGroup[] = []
  sortFields: EmployerSortField[] = []

  constructor(data?: unknown) {
    super(data)

    const blocks = EmployerFilters.extractBlocks(data)
    if (!blocks.length) return

    for (const block of blocks) {
      const group = new EmployerFilterGroup(block)
      if (group.type === 'sort') {
        this.sortFields = group.items.map(item => new EmployerSortField({ id: item.id, name: item.name }))
      }
      else {
        this.groups.push(group)
      }
    }
  }

  private static extractBlocks(data: unknown): unknown[] {
    if (Array.isArray(data)) return data
    if (isUnknownObject(data) && Array.isArray(data.data)) return data.data
    return []
  }

  get allowedFilterKeys(): string[] {
    const keys: string[] = []
    for (const group of this.groups) {
      if (group.type === 'checkbox') {
        for (const item of group.items) {
          if (item.id !== '' && item.id !== undefined) {
            keys.push(String(item.id))
          }
        }
      }
      else if (group.type === 'multiselect' && group.name) {
        keys.push(group.name)
      }
    }
    return keys
  }

  get allowedSortKeys(): string[] {
    return this.sortFields.map(field => field.id)
  }

  resolveSortKey(querySort: unknown): string {
    const querySortStr = querySort != null ? String(querySort) : ''
    if (querySortStr && this.allowedSortKeys.includes(querySortStr)) {
      return querySortStr
    }
    return ''
  }

  get defaultSortKey(): string {
    if (this.allowedSortKeys.includes(DEFAULT_SORT_KEY)) {
      return DEFAULT_SORT_KEY
    }
    return this.allowedSortKeys[0] ?? ''
  }
}

registerModel(EmployerFilters)
